import { useRef } from "react";
import sliderimg from "../../../styles/images/cnbc-default-image.webp";
import Link from "next/link";
import { baseUrlAdmin } from '../../../services/Requests';
import VideoDuration from "../../HelperComponents/VideoDuration";
import Thumbnail from "../../Thumbnail";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide ,Navigation,Pagination} from 'apps/frontend/components/SwiperClient/SwiperClient';
import Title from "../../Title";
import { getSlugOrTitleWithDashes } from "apps/frontend/services/Util";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HorizontalEpisodesSlider = ({ episodes }) => {

    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    return (
        <>
            <div className="newsSliderText newsSlider2Text video_newsSlider_wrap">
                <div className="TileBar scrollbarHeader heading_border">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="float-end">
                                <Title styles={'yellowTitle'}>
                                    <h3>أحدث الحلقات</h3>
                                </Title>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="sliderArrows text-start">
                                <button
                                    className="slider-arrow arrow-prev"
                                    ref={navigationPrevRef}
                                >
                                    Previous
                                </button>
                                <button
                                    className="slider-arrow arrow-next"
                                    ref={navigationNextRef}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <Swiper
                    navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                    }}
                    dir="rtl"
                    slidesPerView={4}
                    spaceBetween={20}
                    slidesPerGroup={1}
                    breakpoints={{
                        // '1800': { slidesPerView: 3 },
                        '1024': { slidesPerView: 4 },
                        '992': { slidesPerView: 4 },
                        '575': { slidesPerView: 3 },
                        '375': { slidesPerView: 1.5 },
                        '320': { slidesPerView: 1.5 },
                    }}
                    pagination={false}
                    modules={[Navigation, Pagination]}
                    className="mySwiper"
                >
                    {
                        episodes?.length > 0 && episodes.map((episode: any, index: number) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div className="slider-item" key={index}>
                                        <div className="NewsBox ">
                                            <Link href={`/episode/${episode?.id + '/' + getSlugOrTitleWithDashes(episode?.title, episode?.seDetails?.slugLine)}`}>
                                                <a href="#" aria-label="Go to 75">
                                                <div className="newsImage">
                                                    <Thumbnail showThumbnail={true} className="img-fluid" src={episode?.thumbnail?.url ? episode?.thumbnail?.url : episode?.thumbnail?.path ? baseUrlAdmin + episode?.thumbnail?.path : sliderimg.src} />
                                                    <div className="PlayTime">
                                                        <VideoDuration data={episode?.video} />
                                                        <div className="PlayButton-featured_50 PlayButton-base " data-type="play">
                                                            <span className="PlayButton-flyout">شاهد الآن</span>
                                                            <span className="icon-play-triangle PlayButton-icon">
                                                                <i className="fa play_medium"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                </a>
                                            </Link>
                                            <div className="newscontent">
                                                <h5>
                                                    <Link href={`/episode/${episode?.id + '/' + getSlugOrTitleWithDashes(episode?.title, episode?.seDetails?.slugLine)}`}>
                                                        <a href="#" aria-label={episode?.title}>{episode && episode?.title}</a>
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </div>
        </>
    )
}

export default HorizontalEpisodesSlider